import React, { useEffect } from "react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { Input, InputOnChangeData } from "semantic-ui-react";
import { PhosphorMagnifyingGlass } from "./PhosphorIcon";
import { Loading } from "components/panels";
import { focusOnMount } from "utilities/reactUtils";

interface Props {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  className?: string

  isLoading?: boolean
  placeholder?: string
  focusOnMount?: boolean
  hasError?: boolean
  maxLength?: number
}

export const SearchInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      focusOnMount(semanticRef.ref.current);
    }
  }, []);

  return <Input
    ref={semanticRef.refSetter}
    className={props.className}
    error={props.hasError}
    icon
    style={{ position: "relative" }}
    fluid
    placeholder={props.placeholder}
    onKeyDown={props.onKeyDown}
    onChange={props.onChange}
    value={props.value}
    maxLength={props.maxLength}
  >
    <input />
    <i className="icon" style={{ paddingTop: 6 }}>
      {!props.isLoading && <PhosphorMagnifyingGlass />}
      {props.isLoading && <Loading />}
    </i>
  </Input>
}